export function shipmentShippingServicesValidate(ss){
    var result = true;
    var errors = [];

    result = validateSS(ss, errors);
    
    if(!result) return errors;
    else return result;
}

function validateSS(ss, errors){    
    if (Array.isArray(ss) 
    && ss.length > 0 
     && ss.every(item =>
        typeof item === 'object' &&
        item !== null &&
        typeof item.id === 'number' &&
        !isNaN(item.id) &&
        typeof item.name === 'string' &&
        item.name !== '' &&
        typeof item.service_code === 'string' &&
        item.service_code !== '' &&
        typeof item.package_type === 'string' &&
        item.package_type !== ''
    )) return true;
    else {
        errors.push("shipping_service_not_valid")
        return false;
    }
}
